import moment from 'moment'
import { notificationsCollection } from '../services/firebase'
import emailApi from '@/services/email'
import router from '.././router'

export default {
  state: {
    notifications: [],
    notification: {
      message: '',
      isRead: false,
      notifier: null,
      receiver: null,
      taskId: null,
      createdAt: moment().toISOString(),
      updatedAt: moment().toISOString(),
    },
    hasUndreadNotifications: false,
  },
  actions: {
    async fetchNotifications({ commit, rootState }, payload = false) {
      const userId = rootState.user.user.data.uid
      const notifications = []
      commit('SET_HAS_UNREAD_NOTIFICATIONS', false)

      const query = notificationsCollection
        .where('receiver', '==', userId)
        .orderBy('isRead')
        .orderBy('createdAt', 'desc')

      if (payload) query.limit(20)

      const notificationsDoc = await query.get()
      notificationsDoc.docs.forEach(doc => {
        if (!doc.data().isRead) commit('SET_HAS_UNREAD_NOTIFICATIONS', true)
        notifications.push({ id: doc.id, ...doc.data() })
      })

      commit('SET_NOTIFICATIONS', notifications)
    },
    async createNotification(context, { notification }) {
      console.log(notification)
      await notificationsCollection.add(notification)
    },
    async markAsRead({ dispatch }, notification) {
      if (!notification.isRead) await notificationsCollection.doc(notification.id).update({ isRead: true, updatedAt: moment().toISOString() })
      dispatch('fetchNotifications')
      router.push({ name: 'taskId', params: { id: notification.taskId } }).catch(err => {})
    },
    async notifyUser({ state, rootState, dispatch }, { receiverId, subject, message, taskId }) {
      const receiverUser = await dispatch('fetchUserById', { userId: receiverId }, { root: true })
      const currentUser = rootState.user.user.data

      const emailData = {
        subject,
        recipients: [receiverUser.email],
        body: `
          <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
          <html xmlns="http://www.w3.org/1999/xhtml">
            <body>
              <h3>Dear ${receiverUser.name}</h3>
              <p>${currentUser.displayName} ${message}.</p>
              <span>You can find it on <a href="https://freelance.trafficlab.dk/#/task/${taskId}">https://freelance.trafficlab.dk/#/task/${taskId}</a>.</span>
            </body>
          </html>
          `,
      }
      await emailApi.sendEmail(emailData)

      state.notification.message = message
      state.notification.notifier = { id: currentUser.uid, name: currentUser.displayName }
      state.notification.receiver = receiverId
      state.notification.taskId = taskId

      await dispatch('createNotification', { notification: state.notification })
    },
  },
  mutations: {
    SET_NOTIFICATIONS(state, payload) {
      state.notifications = payload
    },
    SET_HAS_UNREAD_NOTIFICATIONS(state, payload) {
      state.hasUndreadNotifications = payload
    },
  },
  getters: {
    hasUndreadNotifications(state) {
      return state.hasUndreadNotifications
    },
    notifications(state) {
      return state.notifications
    },
  },
}
